module.exports = __webpack_public_path__ + "media/images/icons/filled/safety-certificate-78d443ce50caacb65924ee45fc0a1f5a.svg";